import React, { PropTypes } from 'react';
import { TextField } from 'material-ui';
import FlatButton from '../../../tc-ui/flat-button-with-loader';
import TwoColumnRow from '../../../tc-ui/two-column-row';
import StepperActions from '../../generic-components/stepper-actions';
import BankInfo from './billing/bank-info';
import InsuranceInfo from './billing/insurance-exp';
import R from 'ramda';

const checkIfShouldDisable = data => {
  if (R.contains('billing', data.title)) {
    return !Boolean(
      data.terms &&
      data.financialInstitution &&
      data.branch &&
      data.accountName &&
      data.accountNumber &&
      data.bsbRoutingNumber
    );
  }
  return !Boolean(
    data.insuranceExpirationMonth &&
    data.insuranceExpirationYear &&
    data.insuranceFiles &&
    data.insuranceFiles.length > 0 &&
    (data.insuranceFiles[0].fileName || data.insuranceFiles[0].name)
  );
};

const BillingInfo = ({ onRequestClose, contractId, onTextFieldChange, saveBillingInfoChanges, attachInsFile, removeInsFile, data, saving }) => {
  const { insuranceExpirationMonth, insuranceExpirationYear, insuranceFiles, ...forBankInfo } = data;
  const shouldDisable = checkIfShouldDisable(data);
  const termsError = data.terms === '' ? 'Payment terms required.' : '';
  const financialInstitutionError = data.financialInstitution === '' ? 'Financial instituation required.' : '';
  const branchError = data.branch === '' ? 'Branch required.' : '';
  const accountNameError = data.accountName === '' ? 'Account name required.' : '';
  const accountNumberError = data.accountNumber === '' ? 'Account number required.' : '';
  const bsbRoutingNumberError = data.bsbRoutingNumber === '' ? 'BSB/Routing number required.' : '';
  const currencyError = data.currency === '' ? 'Currency type required.' : '';
  const insExpMonthError = data.insuranceExpirationMonth === '' ? 'Valid insurance expiration month required.' : '';
  const insExpYearError = data.insuranceExpirationYear === '' ? 'Valid insurance expiration year required.' : '';

  return (
    <div>
      {
        R.contains('billing', data.title) ? (
          <div style={{ marginLeft: '20px', width: '90%', padding: '2% 0%' }}>
            <p style={{ color: '#757575', fontSize: '14px' }}>Please enter your bank and payment information. Buyers will use this infromation to send payment for products that they’ve sold for you.</p>
            <TwoColumnRow
              outerContainerStyle={{ display: 'flex', alignItems: 'center' }}
              leftColumnContent="Payment terms"
              leftColumnStyle={{ width: '35%', color: 'rbga(0, 0, 0, 0.77)' }}
              rightColumnStyle={{ width: '65%', overflowY: 'hidden' }}
              rightColumnContent={
                <textarea
                  style={{ overflowX: 'hidden', width: '100%' }}
                  defaultValue={forBankInfo.terms}
                  rows={4}
                  onChange={(e) => onTextFieldChange({ key: 'terms', value: e.target.value })}
                />
              }
            />
            <BankInfo
              {...forBankInfo}
              onChange={onTextFieldChange}
              financialInstitutionError={financialInstitutionError}
              branchError={branchError}
              accountNameError={accountNameError}
              accountNumberError={accountNumberError}
              bsbRoutingNumberError={bsbRoutingNumberError}
              currencyError={currencyError}
            />
          </div>
        ) : (
          <div style={{ marginLeft: '20px' }}>
            <InsuranceInfo
              {...forBankInfo}
              insExpMonthError={insExpMonthError}
              insExpYearError={insExpYearError}
              insuranceExpirationMonth={insuranceExpirationMonth}
              insuranceExpirationYear={insuranceExpirationYear}
              attachFile={attachInsFile}
              removeFile={removeInsFile}
              attachedFiles={insuranceFiles}
              onChange={onTextFieldChange}
            />
          </div>
        )
      }
      <StepperActions rightButtons={
        <div style={{ marginTop: '5%' }}>
          <FlatButton
            label="Cancel"
            hoverColor="none"
            labelStyle={{ fontWeight: '600', marginRight: '15px' }}
            primary
            onTouchTap={onRequestClose}
          />
          <FlatButton
            label="Save"
            hoverColor="none"
            labelStyle={{ fontWeight: '600' }}
            onTouchTap={() => saveBillingInfoChanges({
              contractId,
              data: R.omit(['title'], data),
              type: R.contains('billing', data.title) ? 'billingInfo' : 'insuranceInfo',
            })}
            loader={saving}
            secondary
            disabled={shouldDisable}
          />
        </div>
        }
      />
    </div>
  );
};

BillingInfo.propTypes = {
  onRequestClose: PropTypes.func,
  contractId: PropTypes.string,
  data: PropTypes.object,
  onTextFieldChange: PropTypes.func,
};

export default BillingInfo;



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/add-edit-dialog-content/billing-info.jsx